import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectAll, selectEntities, State } from './lib/department/department.reducer';

export * from './lib/department-api/department-api.actions';
export * from './lib/department-api/department-api.effects';
export * from './lib/department-ws/department-ws.actions';
export * from './lib/department-ws/department-ws.effects';
export * from './lib/department/department.actions';
export * from './lib/department/department.model';
export * from './lib/shared-department-data-access.module';

export const getState = createFeatureSelector<State>('department');

export const getDepartments = createSelector(getState, selectAll);

export const getDepartmentEntities = createSelector(getState, selectEntities);
